import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ButtonLoaderComponent } from '../../../../shared/components/button-loader/button-loader.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { CustomEditorComponent } from '../../../../shared/components/custom-editor/custom-editor.component';
import { InputWrapperComponent } from '../../../../shared/components/input-wrapper/input-wrapper.component';
import { QuestionModel } from '../../../../shared/models/faq.model';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-add-edit-question',
  standalone: true,
  templateUrl: './add-edit-question.component.html',
  styleUrl: './add-edit-question.component.scss',
  imports: [
    SharedModule,
    ButtonComponent,
    ButtonLoaderComponent,
    InputWrapperComponent,
    CustomEditorComponent,
  ],
})
export class AddEditQuestionComponent implements OnInit {
  @Output() onClose = new EventEmitter();
  @Input() set editQuestion(value: QuestionModel | null) {
    this.questionForm.patchValue({
      question: value?.question || '',
      answer: value?.answer || '',
    });
  }
  @Output() onSubmit = new EventEmitter<QuestionModel>();
  @Input() loading = false;
  @Input() reset = false;

  questionForm: FormGroup = this.fb.group({
    question: ['', [Validators.required]],
    answer: ['', [Validators.required]],
  });
  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {}
  submit() {
    if (this.questionForm.invalid) {
      this.questionForm.markAllAsTouched();
      return;
    }
    const { question, answer } = this.questionForm.value;
    this.onSubmit.emit({ question, answer, id: this.editQuestion?.id });
    if (this.reset) {
      this.questionForm.reset();
    }
  }
  handleClose() {
    this.onClose.emit();
    this.questionForm.reset();
  }
}
